import React from 'react';
import cn from 'classnames';

import dash_styles from './mychargers.module.scss';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';

import TripAndCharge from './trip_and_charge_component/TripAndCharge'
import ViewTripCharge from './trip_and_charge_component/viewTripCharge'

export default function TripAndChargeSchedule(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1]
  return (
      <div
        className={`dash-board1 ${cn(
          dash_styles.main_block,
          dash_styles.main_block_layout
        )}`}>
       
        <div className={cn(dash_styles.main_flex, dash_styles.main_flex_layout)}>
          <Header page_name='My Chargers'></Header>
          { Urls==='/TripAndChargeSchedule'?<ViewTripCharge/>:
            <TripAndCharge/>
          }  
          <Footer></Footer>
        </div>
      </div>
  );
}

TripAndChargeSchedule.inStorybook = true;